// extracted by mini-css-extract-plugin
export default {"lntTextArea":"styles_lnt-text-area__oGVam"};